import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {

  },
  tdc: {
    '&:before':{
        color: theme.palette.primary.main,
    }
  },  
  details: {
    textAlign:"center",
  },
  detailIcon: {
    color: theme.palette.warning.main,
    cursor:"pointer",
  },
  deviceName: {
    color: theme.palette.primary.light,
}
}));
